import { useCallback } from 'react';
import { FileUploadMetaDataExtractionDto } from '@asset-metrix/portal-gateway-client-js';
import { FetchOptionsFunction, FileData } from '@asset-metrix/portal-ui';
import { JsonSchema } from '@sagold/react-json-editor';
import { useQueryClient } from '@tanstack/react-query';

import { fetchDocUploadModalValues } from '../../api/portalGateway/docviewUploadFormValues';
import { uploadDocument } from '../../api/portalGateway/fileUpload';

import { DocUploadModalComponent } from './DocUploadModalComponent';

export type DocUploadModalProps = {
  acceptedMimeTypes?: string[];
  contentId: string;
  documentMetaDataExtraction: FileUploadMetaDataExtractionDto | undefined;
  jsonSchema: JsonSchema;
  onClose: () => void;
  onUploadSuccess?: () => Promise<unknown>;
  withinPortal?: boolean;
};

export function DocUploadModal({
  acceptedMimeTypes,
  contentId,
  documentMetaDataExtraction,
  jsonSchema,
  onClose,
  onUploadSuccess,
  withinPortal,
}: DocUploadModalProps) {
  const queryClient = useQueryClient();

  const fetchConditionalFilterOptions = useCallback<FetchOptionsFunction>(
    async (filter) => {
      const result = await queryClient.fetchQuery({
        queryKey: ['tableModalValues', { contentId, filter }],
        queryFn: fetchDocUploadModalValues,
      });
      return result || {};
    },
    [contentId, queryClient]
  );

  const uploadFile = useCallback(
    async (filedata: FileData, metadata: Record<string, unknown>) => {
      await uploadDocument(filedata.file, contentId, metadata);
    },
    [contentId]
  );

  return (
    <DocUploadModalComponent
      acceptedMimeTypes={acceptedMimeTypes}
      contentId={contentId}
      documentMetaDataExtraction={documentMetaDataExtraction}
      fetchConditionalFilterOptions={fetchConditionalFilterOptions}
      jsonSchema={jsonSchema}
      onClose={onClose}
      onUploadSuccess={onUploadSuccess}
      uploadFile={uploadFile}
      withinPortal={withinPortal}
    />
  );
}
